import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_SITEMAP_LINKS } from '@/graphql/queries';
import SubLink from './SubLink';
import MainLink from './MainLink';
const SitemapPage = () => {
  const $ = _c(21);
  const {
    loading,
    data
  } = useSuspenseQuery(GET_SITEMAP_LINKS);
  if (loading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div><ProgressLoader /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const {
    category_links: t0,
    customer_service_links,
    other_links
  } = data.sitemap_links;
  const {
    mainCategories,
    subCategories
  } = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-[2rem] mb-[5px]">Shop By Category</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== mainCategories || $[3] !== subCategories) {
    t2 = mainCategories && mainCategories.map(t3 => {
      const {
        name,
        url,
        id
      } = t3;
      return <ul key={url} className="text-[#484848] list-none pt-0 px-0 pb-5"><li><MainLink {...{
            name,
            url,
            id
          }} />{subCategories[id] && <ul className="list-none pt-0 pr-0 pb-0 pl-[25px] mt-0 mx-0 mb-[15px]">{subCategories[id].map(_temp)}</ul>}</li></ul>;
    });
    $[2] = mainCategories;
    $[3] = subCategories;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="mt-0 mx-0 mb-10">{t1}<div className="block [column-count:3] [column-gap:20px] list-none m-0 max-[767px]:[column-count:2] max-[568px]:[column-count:1]">{t2}</div></div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-[2rem] mb-[5px]">Customer Service</div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== customer_service_links) {
    t5 = customer_service_links && customer_service_links.map(_temp2);
    $[8] = customer_service_links;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className="mt-0 mx-0 mb-10">{t4}<ul className="block [column-count:1] list-none m-0">{t5}</ul></div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="text-[2rem] mb-[5px]">{"Company & Other Information"}</div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== other_links) {
    t8 = other_links && other_links.map(_temp3);
    $[13] = other_links;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <div className="mt-0 mx-0 mb-10">{t7}<ul className="block [column-count:3] [column-gap:20px] list-none m-0 max-[767px]:[column-count:2] max-[568px]:[column-count:1]">{t8}</ul></div>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t3 || $[18] !== t6 || $[19] !== t9) {
    t10 = <div className="p-10 max-w-[1440px] mx-auto my-0">{t3}{t6}{t9}</div>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
export default SitemapPage;
function _temp(linkProps) {
  return <SubLink {...linkProps} key={linkProps.url} />;
}
function _temp2(linkProps_0) {
  return <SubLink {...linkProps_0} key={linkProps_0.url} />;
}
function _temp3(linkProps_1) {
  return <SubLink {...linkProps_1} key={linkProps_1.url} />;
}